export default __webpack_public_path__ + "static/media/36I-114284_-20948_0.311d0f57.jpg";